type GeoIconProps = {
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const GeoIcon = ({size = 24, color = 'rgb(16,24,40)', className, style}: GeoIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={className}
      style={style}
    >
      <rect width="24" height="24" x="0" y="0" />
      <path
        d="M18.5 9.48264C18.5 11.156 18.2433 12.324 17.339 13.8289C16.4097 15.3756 14.8032 17.2663 12.0033 20.2688C9.19984 17.2661 7.59173 15.3752 6.66161 13.8286C5.75667 12.3238 5.5 11.1559 5.5 9.48264C5.5 6.42376 8.33729 3.5 12 3.5C15.6627 3.5 18.5 6.42376 18.5 9.48264ZM20 9.48264C20 13.2921 18.7554 15.2558 12.732 21.6858C12.3389 22.1055 11.6687 22.1057 11.2753 21.6862C5.24465 15.2559 4 13.2922 4 9.48264C4 5.5243 7.58172 2 12 2C16.4183 2 20 5.5243 20 9.48264ZM13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.1716 11.5 10.5 10.8284 10.5 10C10.5 9.17157 11.1716 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10ZM15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};
